import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ModalCloseOptions } from 'constants/modalCloseOptions';

import styles from './ModalCloseButton.scss';

const ModalCloseButton = memo(({ close, disabled = false, fullScreen = false }) => (
  <button
    aria-label="Close"
    className={classNames(styles.closeButton, {
      [styles.fullScreen]: fullScreen,
      [styles.disabled]: disabled,
    })}
    disabled={disabled}
    id="modalCloseButton" // iOS/Android apps rely on this id!
    onClick={() => close(ModalCloseOptions.CANCEL)}
    type="button"
  >
    <span className="sr-only">Close</span>
  </button>
));

ModalCloseButton.propTypes = {
  close: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  fullScreen: PropTypes.bool,
};

ModalCloseButton.displayName = 'ModalCloseButton';

export default ModalCloseButton;
